import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { type ContentLanguage } from '@@lib/i18n/constants';

export const collectionListQuery = (
    query: { q?: string; empty?: boolean },
    contentLocale: ContentLanguage,
) =>
    client.tenant.collection.getAll.queryOptions({
        query,
        headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
    });
